import styles from "./TodayMapCount.module.css";

/**
 * @interface
 * @prop {number} total 전체 지도 수
 * @prop {string} size 컴포넌트 크기(large: 하단용 / small: 상단용)
 */
interface TodayMapCountProps {
    today: number;
    size: string;
}

/**
 * 오늘의 지도 카운트
 * @author mjkang
 * @date 2022-08-24 10:34:20
 * @param props {@link TodayMapCountProps}
 * @returns TodayMapCount
 */
const TodayMapCount = (props: TodayMapCountProps) => {
    const size = props.size === "large" ? styles.large : styles.small;
    const br =
        props.size === "large" ? (
            <span className={styles.inner}>
                TODAY
                <br />
            </span>
        ) : null;

    return (
        <div className={styles.today}>
            <p className={[styles.title, size].join(" ")}>{br}오늘의 지도</p>
            <p className={[styles.count, size].join(" ")}>{props.today}</p>
        </div>
    );
};

export default TodayMapCount;
